<template>
  <div class="text-center">
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-card-title class="justify-left">
          <h1 class="headline primary--text text--accent-2">
            {{ title }}
            <v-icon
              class="pt-3 pr-3"
              style="right:0px;top:0px;position:absolute;"
              color="primary"
              medium
              @click="show = false"
              >mdi-close</v-icon
            >
          </h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5 pb-1"
          ><p class="pl-3">{{ dialogContent }}</p>
          <v-col align="center" justify="middle">
            <p></p>
            <p></p>
          </v-col>
        </v-card-text>
        <v-divider class="py-1"></v-divider>
        <v-card-actions class="pr-3 pb-3">
          <v-btn
            color="grey"
            class="white--text text-capitalize"
            @click="show = false"
            ><span>{{ $cmsService.getContent(content, 'cancel') }}</span></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="white--text text-capitalize"
            @click="$emit('confirmed', true)"
            ><span>{{ button }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import dialogJson from '@/data/dialog.json'
export default {
  name: 'ConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    dialogContent: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    content: dialogJson.data
  }),
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
